module.exports = __webpack_public_path__ + "68c6eafb3e4cf2035dc9bd8118a371cc.svg";